
import BEERICON from '../assets/images/vectorBEER.jpg';
import SNACKSICON from '../assets/images/vectorSNACKS.jpg';
import LIQUORICON from '../assets/images/vectorLIQUOR.jpg';
import MIXERSICON from '../assets/images/vectorMIXERS-SUPPLIES.jpg';
import PHARMACYICON from '../assets/images/vectorPHARMACY.jpg';
import WHITEWINEICON from '../assets/images/vectorWHITEWINE.jpg';
import SPARKLINGWINEICON from '../assets/images/vectorSPARKLINGWINE.jpg';
import REDWINEICON from '../assets/images/vectorREDWINE.jpg';
import ROSEWINEICON from '../assets/images/vectorROSEWINE.jpg';
import TOBACCOICON from '../assets/images/vectorTOBACCO.jpg';

const menuDepKeys = {
    "WHITE WINE": {
        label: 'Pinot Grigio • Sauv Blanc • Chard',
        icon: WHITEWINEICON
    },
    "SPARKLING WINE": {
        label: 'Champagne • Prosecco • Brut',
        icon: SPARKLINGWINEICON
    },
    "RED WINE": {
        label: 'Cabernet • Pinot Noir • Malbec',
        icon: REDWINEICON
    },
    "ROSE WINE": {
        label: 'French • Local',
        icon: ROSEWINEICON
    },
    "MIXERS & SUPPLIES": {
        label: 'Juice • Coffee • Soda • Ice',
        icon: MIXERSICON
    },
    "PHARMACY & MORE": {
        label: 'Medicine • Household Goods • Pet Food',
        icon: PHARMACYICON
    },
    "TOBACCO": {
        label: 'Cigars • Cigarettes • E Cigs',
        icon: TOBACCOICON,
    },
    "LIQUOR": {
        label: 'Whiskey • Tequila • Scotch • Vodka • Rum',
        icon: LIQUORICON
    },
    "SNACKS": {
        label: 'Chips • Cookies • Cheese • Candy',
        icon: SNACKSICON
    },
    "BEER": {
        label: 'Domestic • Craft • Import',
        icon: BEERICON
    }
};
export default menuDepKeys;


// WEBPACK FOOTER //
// ./src/utils/menuHelper.js